import { render, staticRenderFns } from "./hygc.vue?vue&type=template&id=67e9f12a&scoped=true&"
import script from "./hygc.vue?vue&type=script&lang=js&"
export * from "./hygc.vue?vue&type=script&lang=js&"
import style0 from "./hygc.vue?vue&type=style&index=0&id=67e9f12a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e9f12a",
  null
  
)

export default component.exports